import { render, staticRenderFns } from "./TotalLoyaltyMembersCard.vue?vue&type=template&id=8997b686&scoped=true"
import script from "./TotalLoyaltyMembersCard.vue?vue&type=script&lang=js"
export * from "./TotalLoyaltyMembersCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8997b686",
  null
  
)

export default component.exports